<template>

    <div style="display: contents;">
		<template v-if="buttonComponent == 'v-btn'">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-on="{ ...tooltip }"
						:fab="params.fab ? params.fab : false"
						:icon="params.fab ? false : true"
						:small="params.small ? true : false"
						:fixed="params.fixed ? true : false"
						:bottom="params.bottom ? true : false"
						:right="params.right ? true : false"
						:dark="params.dark ? true : false"
						:color="params.button_color ? params.button_color : ''"
						@click="toggleDialog(true)">
                        <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params ? params.color : ''">{{ icon }}</v-icon>
					</v-btn>
				</template>
        		<span>{{ tooltipText }}</span>
    		</v-tooltip>
		</template>

        <v-list-item v-else-if="buttonComponent == 'v-list-item'"
			dense
			:disabled="disabled"
			@click.stop="toggleDialog(true)"
			ripple>
			<v-list-item-icon>
				<v-icon style="font-size: 18px">{{ icon }}</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>{{ tooltipText }}</v-list-item-title>
			</v-list-item-content>
		</v-list-item>

        <convert-document-dialog
            :open.sync="show"
            :model-def="modelDef"
            :params="dialogParams"
            :selectedIds="[model.id]"
            :selected="[{'id': model.id}]"
            @close="toggleDialog(false)"
            @success="onCreated"
        ></convert-document-dialog>
    </div>
</template>

<script>
    import ConvertDocumentDialog from '@/components/common/ConvertDocumentDialog'

    export default {
        name: 'generate-servicedesk-button',
        components: {
            ConvertDocumentDialog
        },

        props: {
            button: Object,
		    buttonComponent: {type: String, default : 'v-btn'},
            model: Object,
            modelDef: String,
            params: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            disabled: Boolean
        },

        data() {
            return {
                show: false
            }
        },

        computed: {

            // Params passati al dialog condiviso, con url dedicato per-id (endpoint live
            // single-order): il backend espone la base 'saleorders-generate-helpdesktrouble',
            // qui si appende /{id} come fanno le altre azioni singole (apiActionRedirect).
            dialogParams() {
                return {
                    ...this.button.params,
                    url: this.button.params.url + '/' + this.model.id
                }
            },

            icon() {
                if (this.button.params && this.button.params.icon) {
                    return this.button.params.icon
                } else {
                    return 'mdi-face-agent'
                }
            },

            tooltipText() {
                if (this.button.params && this.button.params.tooltip) {
                    return this.button.params.tooltip
                } else {
                    return 'Genera Ticket Service Desk'
                }
            },
        },

        methods: {
            toggleDialog(value) {
                this.show = value
            },

            // Ticket creato live: naviga alla sua scheda (o al ticket esistente, se l'ordine
            // era già collegato — il backend è idempotente e ritorna comunque l'id).
            onCreated(data) {
                this.show = false
                if (data && data.id) {
                    this.$eventBusUtility.goTo(this.$router, this.button.params.route || 'helpdesktroubles-show', data.id)
                }
            }
        }
    }
</script>
